const $kutil = require('@/kabala/js/kutil')
const Funcs = {
    /**
     * 判断是否是 XX 类型
     */
    isType: function( obj, type ){
        try{
            var testType = Object.prototype.toString.call(obj).slice(8,-1).toLowerCase( );
            return (testType === type.toLowerCase( ));
        }catch( e ){
            return false;
        }
    },
    /**
     * 拓展|覆盖对象属性
     * B_IsCopy 指定是否使用拷贝的方式给原有对象添加属性, 默认使用拷贝方式
     */
    extendAttrs: function( OB_Src, OB_Add, B_IsCopy ){
        if( !OB_Src ){
            return OB_Add;
        }
        if(!Funcs.isType( OB_Src, "object" )){
            OB_Src = {};
        }
        for( var Tx_Key in OB_Add){
            if(Funcs.isType( OB_Add[ Tx_Key ], "object" ) && B_IsCopy !== false ){
                OB_Src[ Tx_Key ] = Funcs.extendAttrs(OB_Src[Tx_Key], OB_Add[ Tx_Key ]);
            }else{
                OB_Src[Tx_Key] = OB_Add[ Tx_Key ];
            }
        }
        return OB_Src;
    },
    /**
     * 拓展Object属性 - 浅拷贝
     */
    objmerge: function( obj, addObj ){
        if( !obj ){
            obj = {};
        }
        if( !addObj ){
            return obj;
        }
        for(var key in addObj ){
            if( addObj[key] == undefined ){
                continue;
            }
            if( null == addObj[key] ){
                addObj[key] = "";
            }
            obj[key] = addObj[key];
        }
        return obj;
    },
    // 临时毁掉函数
    callbacks:{ },
    // 获取回调
    getCallback: function(id){
        return Funcs.callbacks[id.toString( )];
    },
    // 添加回调
    addCallback: function(callback){
        let random = $kutil.random( );
        Funcs.callbacks[random.toString( )] = function( ){
            callback.apply({}, arguments );
            delete Funcs.callbacks[random.toString( )];
        };
        return random;
    },
    // 执行回掉
    doCallback: function( ){
        let cb = Funcs.getCallback(arguments[0]);

        let args = [];
        for(var i=0; i<arguments.length; i++){
            if( i == 0 ){ continue; }
            args.push( arguments[i] );
        }
        cb.apply({}, args)
    },
    // 检查平台
    checkPlatform: function( typeStr ){
        let res = {
            Win: /Win/i.test(navigator.platform),
            Mac: /Mac/i.test(navigator.platform),
            Linux: /Linux/i.test(navigator.platform),
            iOS: /iOS/i.test(navigator.platform),
        };
        if( typeStr ){
            return res[ typeStr.toString( ) ];
        }else{
            return res;
        }
    },
    /**
     * 判断设备类型 安卓|IOS Web|App
     * @return {[type]} [description]
     */
    checkBrowser: function( typeStr ){
        let res = {
            App: false,
            Iso: false,
            Android: false,
            IsoApp: false,
            AndroidApp: false,
            Browser: false,
        };
        try{
            var ua = navigator.userAgent.toLowerCase( );
            // console.log( ua )
            res.Mobile = ua.indexOf('mobile') > -1;
            res.Iso = /\b(ipad|iphone|ipod)(?=;)/.test(ua);
            res.Android = ua.indexOf('android') > -1;
            try{
                res.App = ($kmobilebridge||window.$kmobilebridge)?true:false;
            }catch(err){}
            res.DingTalk = ua.indexOf('dingtalk') > -1;
            res.WeiXin = ua.match(/MicroMessenger/i)=="micromessenger";
            res.WeiXinMiniProgram = res.WeiXin && ua.indexOf('miniprogram') > -1;
            res.IsoApp = res.App && res.Iso;
            res.AndroidApp = res.App && res.Android;
            res.Browser = !res.IsoApp && !res.AndroidApp;
        }catch(err){}

        if( typeStr ){
            return res[ typeStr.toString( ) ];
        }else{
            return res;
        }
    },

};

module.exports = Funcs